var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "box-sizing",
      staticStyle: {
        width: "100%",
        height: "100%",
        display: "flex",
        "align-items": "center",
        "justify-content": "center",
      },
    },
    [
      _vm.forgetPassword
        ? _c(
            "div",
            {
              staticClass: "ds-container h-100",
              staticStyle: { "justify-content": "center", width: "100%" },
            },
            [
              _c("div", { staticClass: "ds-header" }, [_vm._v("重置密码")]),
              _c(
                "div",
                { staticClass: "reSet-form" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "resetFormRef",
                      attrs: { model: _vm.reSetForm, rules: _vm.rules },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "userName", label: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入你的电话号码/电子邮箱",
                              clearable: "",
                            },
                            model: {
                              value: _vm.reSetForm.userName,
                              callback: function ($$v) {
                                _vm.$set(_vm.reSetForm, "userName", $$v)
                              },
                              expression: "reSetForm.userName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "name", label: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入你的姓名",
                              clearable: "",
                            },
                            model: {
                              value: _vm.reSetForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.reSetForm, "name", $$v)
                              },
                              expression: "reSetForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "idCard", label: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入你的身份证号",
                              clearable: "",
                            },
                            model: {
                              value: _vm.reSetForm.idCard,
                              callback: function ($$v) {
                                _vm.$set(_vm.reSetForm, "idCard", $$v)
                              },
                              expression: "reSetForm.idCard",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "password", label: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入你的登录密码",
                              clearable: "",
                              "show-password": "",
                            },
                            model: {
                              value: _vm.reSetForm.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.reSetForm, "password", $$v)
                              },
                              expression: "reSetForm.password",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "confirmPassword", label: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请再次输入你的登录密码",
                              clearable: "",
                              "show-password": "",
                            },
                            model: {
                              value: _vm.reSetForm.confirmPassword,
                              callback: function ($$v) {
                                _vm.$set(_vm.reSetForm, "confirmPassword", $$v)
                              },
                              expression: "reSetForm.confirmPassword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "w-100 footer",
                  staticStyle: { "margin-top": "10px" },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "submit-btn",
                      attrs: { type: "primary", loading: _vm.submitLoading },
                      on: {
                        click: function ($event) {
                          return _vm.handleReset("submit")
                        },
                      },
                    },
                    [_vm._v("重置密码")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "submit-btn back",
                      attrs: { type: "", loading: _vm.submitLoading },
                      on: {
                        click: function ($event) {
                          return _vm.handleReset("back")
                        },
                      },
                    },
                    [_vm._v("返回")]
                  ),
                ],
                1
              ),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "ds-container h-100",
              staticStyle: { width: "100%", "justify-content": "center" },
            },
            [
              _c("div", { staticClass: "ds-header" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _c(
                "div",
                { class: [_vm.isLogin ? "ds-main" : "reSet-form"] },
                [
                  _c(
                    "el-form",
                    {
                      ref: "loginFormRef",
                      attrs: { model: _vm.formData, rules: _vm.rules },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "userName", label: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入你的电话号码/电子邮箱",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.userName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "userName", $$v)
                              },
                              expression: "formData.userName",
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.isLogin
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: "name", label: "" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入你的姓名",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.formData.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "name", $$v)
                                  },
                                  expression: "formData.name",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isLogin
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: "idCard", label: "" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入你的身份证号",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.formData.idCard,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "idCard", $$v)
                                  },
                                  expression: "formData.idCard",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "password", label: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入你的登录密码",
                              clearable: "",
                              "show-password": "",
                            },
                            model: {
                              value: _vm.formData.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "password", $$v)
                              },
                              expression: "formData.password",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.isLogin
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                "font-size": "16px",
                                color: "#A40000",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.forgetPassword = true
                                },
                              },
                            },
                            [_vm._v("忘记密码？")]
                          )
                        : _vm._e(),
                      !_vm.isLogin
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: "confirmPassword", label: "" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请再次输入你的登录密码",
                                  clearable: "",
                                  "show-password": "",
                                },
                                model: {
                                  value: _vm.formData.confirmPassword,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "confirmPassword",
                                      $$v
                                    )
                                  },
                                  expression: "formData.confirmPassword",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isLogin
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#A40000",
                                "text-align": "right",
                                "line-height": "16px",
                                "margin-bottom": "10px",
                              },
                            },
                            [_vm._v(" 密码8-16位（含字母、数字、特殊字符）")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isLogin
                ? _c(
                    "div",
                    {
                      staticClass: "footer w-100",
                      staticStyle: { "margin-top": "30px" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "submit-btn",
                          attrs: {
                            type: "primary",
                            loading: _vm.submitLoading,
                          },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v(" 登录 ")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "footer w-100" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "submit-btn",
                          attrs: {
                            type: "primary",
                            loading: _vm.submitLoading,
                          },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v(" 注册 ")]
                      ),
                    ],
                    1
                  ),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }